import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import { initSentry } from "@/lib/sentry";
import { ErrorFallback } from "@/components/ErrorFallback";
import "./index.css";

// Initialize Sentry before React mounts so even errors during initial
// render are captured.
initSentry();

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary
    fallback={({ error, resetError }) => {
      // Sentry's fallback contract is `error: unknown` — anything can be
      // thrown, including non-Error values (`throw "string"`,
      // `throw 42`). The fallback is the last line of defense, so don't
      // assume `.message` and `.stack` exist; coerce safely.
      const e = error instanceof Error ? error : new Error(String(error));
      return <ErrorFallback error={e} resetError={resetError} />;
    }}
  >
    <App />
  </Sentry.ErrorBoundary>,
);
